"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useReactiveMap = exports.ReactiveMapProvider = exports.ReactiveMapContext = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importStar(require("react"));

exports.ReactiveMapContext = (0, react_1.createContext)(undefined);

function ReactiveMapProvider(_a) {
  var children = _a.children,
      reactiveMap = _a.reactiveMap;
  var Provider = exports.ReactiveMapContext.Provider;
  return react_1.default.createElement(Provider, {
    value: reactiveMap
  }, children);
}

exports.ReactiveMapProvider = ReactiveMapProvider;

function useReactiveMap() {
  var context = (0, react_1.useContext)(exports.ReactiveMapContext);

  if (!context) {
    throw new Error("It couldn't find a ReactiveMap instance in the context. You are probably missing a SlicesProvider");
  }

  return context;
}

exports.useReactiveMap = useReactiveMap;